import ReactGA from "react-ga4";

declare global {
  interface Window {
    __ga4_initialized__?: boolean;
  }
}

function getMeasurementId(): string | undefined {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
  return id?.trim() ? id.trim() : undefined;
}

function isDebugEnabled(): boolean {
  return String(import.meta.env.VITE_ANALYTICS_DEBUG ?? "").toLowerCase() === "true";
}

export function initAnalytics(): { enabled: boolean } {
  const measurementId = getMeasurementId();
  if (!measurementId) return { enabled: false };

  if (typeof window === "undefined") return { enabled: false };
  if (window.__ga4_initialized__) return { enabled: true };
  window.__ga4_initialized__ = true;

  // `react-ga4` will load gtag.js internally.
  // We disable automatic page_view so React Router can drive pageview events.
  ReactGA.initialize(measurementId, {
    gtagOptions: {
      send_page_view: false,
    },
  });

  if (isDebugEnabled()) {
    console.debug("[analytics] GA4 initialized", { measurementId });
  }

  return { enabled: true };
}

export function getGa4MeasurementId(): string | undefined {
  return getMeasurementId();
}


